// function loaderActive() {
//   const app = document.querySelector('.css-xgm0sd')
//   console.log(app)
// }

export const loader = () => {
  // loaderActive()
}
